import type { PhaseSpaceDimension } from '../../config/schema';
import type { ControlSetupContext } from './helpers';

export function setupPhaseSpaceControls(ctx: ControlSetupContext): void {
  const { config: c, controls: ui } = ctx;

  ui.bindControl('xDimension', (v) => {
    c.phaseSpace.mode = 'manual';
    c.phaseSpace.x.dimension = v as PhaseSpaceDimension;
    ctx.applyAxisDefaults('x');
    ui.updatePhaseSpaceInputs(c);
    ui.ensureDistinctDimensions(c.phaseSpace.x.dimension, c.phaseSpace.y.dimension);
    ui.updateTilingUI(c);
    ctx.resetZoom();
    ctx.markStale();
  }, 'change');

  ui.bindControl('yDimension', (v) => {
    c.phaseSpace.mode = 'manual';
    c.phaseSpace.y.dimension = v as PhaseSpaceDimension;
    ctx.applyAxisDefaults('y');
    ui.updatePhaseSpaceInputs(c);
    ui.ensureDistinctDimensions(c.phaseSpace.x.dimension, c.phaseSpace.y.dimension);
    ui.updateTilingUI(c);
    ctx.resetZoom();
    ctx.markStale();
  }, 'change');

  ['xMin', 'xMax', 'yMin', 'yMax'].forEach(id => {
    ui.bindControl(id, (v) => {
      const val = parseFloat(v);
      if (id === 'xMin') c.phaseSpace.x.min = val;
      else if (id === 'xMax') c.phaseSpace.x.max = val;
      else if (id === 'yMin') c.phaseSpace.y.min = val;
      else if (id === 'yMax') c.phaseSpace.y.max = val;
      ctx.resetZoom();
      ctx.markStale();
    }, 'change');
  });

  const ivMap: Record<string, PhaseSpaceDimension> = {
    initAngle1: 'angle1', initVelocity1: 'velocity1',
    initAngle2: 'angle2', initVelocity2: 'velocity2',
    initStretch1: 'stretch1', initStretchRate1: 'stretchRate1',
    initStretch2: 'stretch2', initStretchRate2: 'stretchRate2',
  };
  Object.entries(ivMap).forEach(([id, dim]) => {
    ui.bindControl(id, (v) => {
      c.phaseSpace.initialValues[dim] = parseFloat(v);
      ctx.markStale();
    }, 'change');
  });

  ui.bindControl('sliceMode', (v) => {
    c.phaseSpace.mode = v as 'manual' | 'tiling';
    if (c.phaseSpace.mode === 'tiling') ctx.regenerateTiling();
    ui.updateTilingUI(c);
    ctx.markStale();
  }, 'change');

  ui.bindControl('tileCols', (v) => {
    c.phaseSpace.tiling.cols = Math.max(1, parseInt(v) || 1);
    ctx.regenerateTiling();
    ui.updateTilingUI(c);
    ctx.markStale();
  }, 'change');

  ui.bindControl('tileRows', (v) => {
    c.phaseSpace.tiling.rows = Math.max(1, parseInt(v) || 1);
    ctx.regenerateTiling();
    ui.updateTilingUI(c);
    ctx.markStale();
  }, 'change');

  ui.bindButton('regenerateTilesBtn', () => {
    ctx.regenerateTiling();
    ctx.markStale();
  });
}
